import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { Modal } from '@/components/Modal'
import { NetworkSelector } from '../NetworkSelector'
import { Info } from '@/assets/icons'
import { SelectBlockchainModalProps } from './types'
import { BlockchainCatalogsDTO } from '@/domain/blockchains'

export const SelectBlockchainModal: React.FC<SelectBlockchainModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  blockchains,
  selectedBlockchain,
  currencyCode: _currencyCode,
}) => {
  const { t } = useTranslation()

  const handleSelect = (blockchain: BlockchainCatalogsDTO) => {
    onSelect(blockchain)
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('translation:networkDetails.selectNetwork')}
      showHandle={true}
    >
      <BaseView
        data-component="select-blockchain-modal"
        style={{
          gap: 12,
          paddingBottom: 20,
        }}
      >
        {/* Blockchain List */}
        <BaseView gap={12}>
          {blockchains.map((blockchain) => (
            <NetworkSelector
              key={blockchain.id}
              blockchain={blockchain}
              onPress={() => handleSelect(blockchain)}
              isSelected={selectedBlockchain?.id === blockchain.id}
            />
          ))}
        </BaseView>

        {/* Warning Footer */}
        <BaseView row align="flex-start" gap={8} px={16} py={12}>
          <BaseView style={{ flexShrink: 0, paddingTop: 2 }}>
            <Info color="#7E8082" size={20} />
          </BaseView>
          <BaseView flex={1}>
            <BaseText
              fontSize={14}
              color="label.description"
              style={{ lineHeight: '20px' }}
            >
              {t(
                'networkDetails.makeSureInSelectNetwork',
                "Make sure you've selected the correct network. Deposits of other assets or from other networks will be lost.",
              )}
            </BaseText>
          </BaseView>
        </BaseView>
      </BaseView>
    </Modal>
  )
}
